import {
  primaryColors,
  transparentColors
} from '@assets/styles/helpers/colors.styles'
import MuiChip from '@mui/material/Chip/Chip'
import { chipImageStyles, chipStyles } from './Chip.styles'

interface ChipProps {
  label: string
  color: 'primary' | 'secondary'
  onClick?: () => void
  onDelete?: () => void
  disabled?: boolean
  chipIcon?: JSX.Element
  chipImg?: string
  uppercase?: boolean
}

function Chip(props: ChipProps) {
  const {
    label,
    onClick,
    onDelete,
    disabled,
    chipIcon,
    chipImg,
    color,
    uppercase
  } = props
  return (
    <MuiChip
      label={label}
      onClick={onClick}
      onDelete={onDelete}
      disabled={disabled}
      size="small"
      icon={!chipImg ? chipIcon ?? undefined : undefined}
      avatar={
        chipImg ? (
          <img src={chipImg} alt="chip-avatar" style={chipImageStyles} />
        ) : undefined
      }
      sx={{
        ...chipStyles,
        textTransform: uppercase ? 'uppercase' : 'none',
        color: color === 'primary' ? primaryColors.white : primaryColors.orange,
        backgroundColor:
          color === 'primary'
            ? transparentColors.whiteShade5
            : transparentColors.orangeShade5
      }}
    />
  )
}

export default Chip
